import React from 'react';
import { FiservCard, FiservCardInterface, useResponsive } from '@common-fe/common-fe';

import { useIsLockCardPurseAvailable } from '@/modules/transaction/components/Cards/hooks/useIsLockCardPurseAvailable';
import { useOrganizationProperties } from '@/modules/transaction/hooks';
import { whiteLabelingConfig } from '@/utils/whiteLabeling';

import { CardItemWrapper } from './ChangeStatusCardModal.styles';

interface CardModalWrapperProps {
  card: FiservCardInterface;
  isLoading: boolean;
  isEmployeeLimitedAccess?: boolean;
}

const CardModalWrapper: React.FC<CardModalWrapperProps> = ({ card, isLoading, isEmployeeLimitedAccess }) => {
  const { organizationProperties } = useOrganizationProperties();
  const { isMobile } = useResponsive();
  const isCardFlipDisabled = useIsLockCardPurseAvailable();

  if (!card) {
    return null;
  }

  return (
    <CardItemWrapper
      $isMobile={isMobile}
      $isFlipDisabled={isCardFlipDisabled}
      margin={{ top: isMobile ? '0' : '-135px', bottom: 'spacing24' }}
    >
      <FiservCard
        card={card}
        logos={{
          logoUrl: organizationProperties?.darkLargeLogoUrl,
          cardLogo: whiteLabelingConfig?.images?.cardLogo,
          defaultCardLogo: whiteLabelingConfig?.logo,
          cardBackground: whiteLabelingConfig?.images?.cardBackground,
        }}
        isFullyMasked={isEmployeeLimitedAccess}
        isLoading={isLoading}
        isActive
        supportsTwoSides
      />
    </CardItemWrapper>
  );
};

export default CardModalWrapper;
